import React from 'react'
import ReactLogo from './ping-logo-horizontal-color.svg'

const PingOneLogo = ({ className = '' }) => {
  if (!ReactLogo) return null
  return <img className={className} src={ReactLogo} />
}

export { PingOneLogo }
